import { PendoAnalytics as e } from "../directives/analytics/pendo-analytics.js";
import { hasSlot as l } from "../utils/utils.js";
const a = {
  directives: {
    PendoAnalytics: e
  },
  props: {
    /**
     * Label text, placed on top of component by default
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Label position, used in combination with `label` prop
     */
    labelPosition: {
      type: String,
      default: "top",
      validator: (t) => ["top", "bottom", "left", "right"].includes(t)
    },
    /**
     * pass multiple labels in the form of
     * `:labels="{ top: 'label text', bottom: 'label text', suffix: 'label text'}"`
     */
    labels: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasTopLabel() {
      return this.topLabel || l(this, "topLabel");
    },
    hasBottomLabel() {
      return this.bottomLabel || l(this, "bottomLabel");
    },
    hasRightLabel() {
      return !!(this.labelPosition === "right" || this.labels.right);
    },
    hasLeftLabel() {
      return !!(this.labelPosition === "left" || this.labels.left);
    },
    topLabel() {
      return this.label && ["top", "left"].includes(this.labelPosition) ? this.label : this.labels.top || this.labels.left;
    },
    bottomLabel() {
      return this.label && ["bottom", "right"].includes(this.labelPosition) ? this.label : this.labels.bottom || this.labels.right;
    },
    inlineLabel() {
      return this.hasRightLabel || this.hasLeftLabel;
    },
    suffixLabel() {
      return this.label && this.labelPosition === "suffix" ? this.label : this.labels.suffix;
    },
    analyticsTagFromLabels() {
      const t = [];
      return this.topLabel && t.push(this.topLabel), this.bottomLabel && t.push(this.bottomLabel), this.inlineLabel && t.push(this.inlineLabel), t.join(" ");
    }
  }
};
export {
  a as default
};
//# sourceMappingURL=labels.js.map
